<script setup>
import TasksPendingAdjuster from "@/Components/TasksPending/TasksPendingAdjuster.vue";
import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-row v-if="Permissions.checkPermissions(['tasks-pending.list-adjuster'])">
    <v-col cols="12">
      <TasksPendingAdjuster/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>